import { HttpService } from "../http";

export class FaqService extends HttpService {
  fetchFaqs = async (baseUrl: any, payload: any): Promise<any> => {
    const apiUrl = `${baseUrl}/api/faq`;
    try {
      const apiResponse = await this.get(apiUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addFaq = async (baseUrl: string, payload: FormData): Promise<any> => {
    const apiUrl = `${baseUrl}/api/faq`;
    try {
      const apiResponse = await this.post(apiUrl, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateFaq = async (baseUrl: any, id: any, payload: any): Promise<any> => {
    const apiUrl = `${baseUrl}/api/faq/${id}`;
    try {
      const apiResponse = await this.patch(apiUrl, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteFaq = async (baseUrl: any, id: any): Promise<any> => {
    const apiUrl = `${baseUrl}/api/faq/${id}`;
    try {
      const apiResponse = await this.delete(apiUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  downloadDocumentsZip = async (
    baseAuthUrl: string,
    documentIds: number[],
    faqId?: number
  ): Promise<any> => {
    try {
      const queryParams: string[] = [];
      queryParams.push(`documentIds=${documentIds.join(",")}`);
      if (faqId) {
        queryParams.push(`faqId=${faqId}`);
      }
      const query = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
      
      const apiResponse = await this.get(
        `${baseAuthUrl}/api/documents/download-zip${query}`,
        null,
        { responseType: "blob" }
      );
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
